import type { SchemaOf } from '../../helpers';
import { Joi, objectSchemaOf } from '../../helpers';

interface IOperationHours {
  start: string;
  end: string;
}

const operationHoursSchema = objectSchemaOf<IOperationHours>({
  start: Joi.string()
    .regex(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)
    .required(),
  end: Joi.string()
    .regex(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)
    .required(),
});

export interface IConfig {
  operationHoursTz?: string;
  operationHoursWeekday?: IOperationHours;
  operationHoursWeekend?: IOperationHours;
}

export const schemaMap: SchemaOf<IConfig> = {
  operationHoursTz: Joi.string().optional(),
  operationHoursWeekday: operationHoursSchema,
  operationHoursWeekend: operationHoursSchema,
};

export const schemaMapDefault = schemaMap;

export const defaultConfig: IConfig = {};
